import { getTranslate } from '@/helpers/translateHelpers';
import { EValidations } from '@/types/enums';

export default class ValidationService {
  static [EValidations.required](
    value: string,
    errors: Array<string>
  ): boolean {
    if (!value.trim()) {
      errors.push(getTranslate('errors.required'));
      return false;
    }

    return true;
  }

  static [EValidations.url](value: string, errors: Array<string>): boolean {
    const validRegex =
      /^(https?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-_.]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9]{2,})+/;
    const message = getTranslate('errors.validDomain');
    if (!validRegex.test(String(value))) {
      errors.push(message);
      return false;
    }

    return true;
  }

  static [EValidations.maxStringLength](
    value: string,
    maxLength = 0,
    errors: Array<string>
  ): boolean {
    if (maxLength && value.trim() && value.trim().length > maxLength) {
      errors.push(getTranslate('errors.maxLength'));
      return false;
    }

    return true;
  }
}
